import { initFlowbite } from 'flowbite'

import '../controllers'

document.addEventListener('turbo:load', () => {
  initFlowbite()
})
